import * as React from "react";
import { IMaskInput } from "react-imask";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import "./components.css";
import CustomTooltip from "./CustomTooltip";
import { FormHelperText, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, mask, ...other } = props;

  return (
    <IMaskInput
      {...other}
      mask={mask}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
    />
  );
});

export default function MaskComponent(props) {
  const { t } = useTranslation();

  const {
    value,
    onChange,
    mask,
    name,
    label,
    required,
    error,
    helperText,
    pattern,
  } = props;

  return (
    <div className="flexAlignColumnClassName" onClick={(e) => { e.preventDefault() }}>
      <InputLabel
        htmlFor="formatted-text-mask-input"
        className="labelClassName alignRowClassName flex-start"
      >
        {t(label)}
        <CustomTooltip title={mask && `(${t('Ex')}:- ${mask})`}>
          <span className="tooltipInfoIcon">i</span>
        </CustomTooltip>
      </InputLabel>
      <FormControl variant="standard">
        <Input
          data-testid="input"
          style={{ padding: 10 }}
          value={value.toString()}
          onAnimationStart={(e) => props.onLoad(e)}
          onChange={(e) => onChange(e)}
          name={name}
          disableUnderline={true}
          inputProps={{ mask: mask, pattern: pattern }}
          className="textFieldInputComponent"
          classes={{
            root: "outlinedInputRoot",
            focused: "outlinedInputFocused",
            notchedOutline: "outlinedInput",
          }}
          inputComponent={TextMaskCustom}
          required={required}
          error={error}
        />
        <FormHelperText>{t(helperText)}</FormHelperText>
      </FormControl>
    </div>
  );
}
